import React from "react";
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  Divider,
  ListSubheader,
  Paper,
  Box,
  IconButton,
  Skeleton,
} from "@mui/material";
import { Stack } from "@mui/system";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export default function WeekStatsSkeleton({
  startLabel,
  endLabel,
  embeddedMode,
  prevWeek,
  nextWeek,
  isCurrentWeek,
}) {
  return (
    <List
      sx={{ height: "100%", overflowY: "auto" }}
      dense
      subheader={
        <ListSubheader
          sx={(theme) => ({
            border: `1px solid ${theme.palette.divider}`,
            width: "100%",
            py: 1,
          })}
          component={Paper}
          elevation={0}
        >
          <Stack
            direction={"row"}
            alignItems={"center"}
            spacing={2}
            sx={{ width: "100%" }}
            justifyContent={"space-between"}
          >
            <Typography variant="body1">Week Stats:</Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {!embeddedMode && (
                <IconButton size="small" onClick={prevWeek}>
                  <ArrowBackIosIcon fontSize="small" />
                </IconButton>
              )}

              <Typography
                variant="body1"
                sx={(theme) => ({ color: theme.palette.text.primary })}
              >
                {startLabel} - {endLabel}
              </Typography>

              {!embeddedMode && (
                <IconButton
                  size="small"
                  onClick={nextWeek}
                  disabled={isCurrentWeek}
                >
                  <ArrowForwardIosIcon fontSize="small" />
                </IconButton>
              )}
            </Box>
          </Stack>
        </ListSubheader>
      }
    >
      {Array.from({ length: 4 }).map((_, idx) => (
        <React.Fragment key={idx}>
          <ListItem disableGutters>
            <ListItemText
              primary={<Skeleton variant="text" width="40%" />}
              secondary={
                <>
                  <Skeleton variant="text" width="30%" />
                </>
              }
            />
          </ListItem>
          {idx < 6 && <Divider component="li" />}
        </React.Fragment>
      ))}
    </List>
  );
}

